<template>
    <div class="error404">
        <div class="full-container">
            <h1>404</h1>

            <h5>Oops! Page Could Not Be Found</h5>

            <p>The page you are looking for might have been removed or is temporarily unavailable.</p>

            <button class="btn btn-ecdc d-block mx-auto mt-4" @click="$router.go(-1)">Go Back</button>


            <app-loader v-show="isLoading"></app-loader>

        </div>
    </div>
</template>

<script>
import Loader from "./Loader";

export default {
    components: {
        appLoader: Loader,
    },
    async mounted() {
        this.isLoading = false;
    },
}
</script>